// Funciones puras de transformación (sin React, sin FHIR — ver nota de
// diseño en tipos.ts, estos datos no crean ningún recurso Medplum) — mismo
// criterio testeable-sin-DOM que `paciente/curvaTermica.ts`.
import type { DatosSignosVitalesPdf } from '@logiacare/hce-pdf';
import { PALETA_SERIES } from '../../../graficos/tema';
import type { EventoPuntual, Serie } from '../../../graficos/tipos';
import { CATALOGO_EVENTOS, CATALOGO_PARAMETROS, type EventoAnestesia, type MedicionPuntual } from './tipos';

/** Agrupa las mediciones por parámetro y arma `Serie[]` para `GraficoSerieTemporal` — un parámetro sin mediciones no genera una serie vacía (evita entradas fantasma en la leyenda). */
export function seriesSignosVitalesAnestesiaDe(mediciones: readonly MedicionPuntual[]): Serie[] {
  const series: Serie[] = [];
  CATALOGO_PARAMETROS.forEach((def, indice) => {
    const puntos = mediciones
      .filter((m) => m.parametro === def.clave)
      .map((m) => ({ x: m.minuto, y: m.valor }))
      .sort((a, b) => a.x - b.x);
    if (puntos.length === 0) return;
    const { color, trazo } = PALETA_SERIES[indice % PALETA_SERIES.length];
    series.push({ id: def.clave, etiqueta: def.etiqueta, color, trazo, unidad: def.unidad, puntos });
  });
  return series;
}

/** Eventos → marcadores verticales para `GraficoSerieTemporal`. */
export function eventosGraficoDe(eventos: readonly EventoAnestesia[]): EventoPuntual[] {
  return eventos.map((e) => ({ x: e.minuto, etiqueta: CATALOGO_EVENTOS.find((c) => c.clave === e.tipo)?.etiqueta ?? e.tipo }));
}

/** Wire format disperso para `EspecificacionPdf` (modo 'msp', campo `diagramaSignosVitales`). */
export function datosSignosVitalesPdf(mediciones: readonly MedicionPuntual[], eventos: readonly EventoAnestesia[]): DatosSignosVitalesPdf {
  return {
    puntos: mediciones.map((m) => ({ parametro: m.parametro, minuto: m.minuto, valor: m.valor })),
    eventos: eventos.map((e) => ({ tipo: e.tipo, minuto: e.minuto })),
  };
}
